<template>
    <div class="group_products">
        <div class="head_group_products">
            <button class="btn btn-md btn-block btn-outline-success waves-effect waves-themed" v-on:click="select_product">
                <span  class="fal  fa-eject mr-1"></span>
                {{__t('SELECT_PRODUCT')}}
            </button>
        </div>

        <div class="products_list">
            <div class="products" v-if="selected_items.length > 0">
               <product_inside_list
                   @remove_product="remove_item"
                   key="prod_list_in_group"
                   :show_select="false"
                   :show_remove="true"
                   :items="selected_items">
               </product_inside_list>
            </div>
        </div>

        <product_search_list
            :exclude_ids="exclude_prod_ids"
            @finish_select="on_finish_select_products"
            @close_product_search="close_select_product"
            v-if="show_product_search"
        >
        </product_search_list>
    </div>
</template>

<script>
import Product_search_list from "../../../products/modal_list/product_search_list.vue";
import vSelect from 'vue-select'
import Product_inside_list from "../../../products/inside_list/product_inside_list.vue";

export default {
    name: "group_products",
    components: {Product_inside_list, Product_search_list,   vSelect},
    props : {
        cur_group : {
            type : Object
        }
    },

    data() {
        return {
            search_items : [],
            selected_items: [],
            show_product_search : false,
            is_load: true,
        }
    },
    methods : {

        on_finish_select_products(products) {
            if (Array.isArray(products) && products.length) {
                products.forEach(item => {
                    if (item && item.id && !this.selected_items.some(prod => parseInt(prod.id) === parseInt(item.id))) {
                        this.selected_items.push(item);
                    }
                });
            }

            this.$emit('on_group_change',{
                "type"     : "products",
                "value" : this.selected_items,
            })
        },

        close_select_product() {
            this.show_product_search = false;
        },

        select_product() {
            this.show_product_search = true;
        },

        remove_item(product_id) {
            this.selected_items = this.selected_items.filter(item => {
                return parseInt(item.id) !== parseInt(product_id);
            });

            this.$emit('on_group_change',{
                "type"  : "products",
                "value" : this.selected_items,
            })
        },
    },

    computed : {
        exclude_prod_ids() {
            let base = [];
            this.selected_items.map(item => {
                base.push(item.id);
            });

            return base;
        },
    },
}
</script>


<style scoped>

</style>
